import { useEffect, useState } from 'react';

import { usePriceSettingsHook } from '../../../Hooks/Maintenance/PriceSettings/priceSettingsHooks';

import { UserTier } from '../../../Models/Maintenance/PriceSettings/PriceSettings';

import { AutoCompleteDropdownInterface } from '../../../Models/Common/FormFieldComponentInterfaces';

import QueryBuilderHelper from '../../../Utilities/Helpers/QueryBuilderHelper';
import GlobalFunctionHelper from '../../../Utilities/Helpers/GlobalFunctionHelper';

import { CachingEnum } from '../../../Utilities/Enums/CachingEnum';
import { CompanyListField, PriceSettingsField } from '../../../Utilities/Enums/ParametersEnum';

import AutoCompleteDropdown from '../AutoCompleteDropdown';

export default function UserCapacityDropdown(fieldProps: AutoCompleteDropdownInterface) {
	let {
		name,
		title,
		fieldValue,
		options,
		isLoadingDropdown,
		disabled,
		required,
		errorMessages,
		handleOnChange,
        hideLabel,
        fieldClassName,
        sideContentPosition,
        sideContent,
        currencyCode = GlobalFunctionHelper.getCurrencyCode(),
	} = fieldProps;

	//Use States
    let [initializingUserTiers, setinitializingUserTiers] = useState<boolean>(true);
    let [userTiers, setuserTiers] = useState<UserTier[]>([]);

    const { getPriceSettings } = usePriceSettingsHook([CachingEnum.PRICE_SETTINGS], currencyCode ?? GlobalFunctionHelper.getCurrencyCode(), false);

    const initializeModules = async () => {
        let getCurrencyPriceSettings = await getPriceSettings({ currencyCode: currencyCode });

        setuserTiers(getCurrencyPriceSettings?.data?.[PriceSettingsField.USER_TIERS] ?? []);
        setinitializingUserTiers(false);
    }

    useEffect(() => {
        initializeModules();
    }, [currencyCode]);

    const userCapacityProps = {
        name: name,
        title: title,
        fieldValue: fieldValue,
        options: userTiers?.map((item: any) => { return { id: item?.[PriceSettingsField.MAX_USERS] ?? "", name: item?.[PriceSettingsField.MAX_USERS] }}) ?? [], 
        isLoadingDropdown: initializingUserTiers,
        disabled: disabled,
        required: required,
        hideLabel: hideLabel,
        errorMessages: errorMessages,
        handleOnChange: handleOnChange,
        fieldClassName: fieldClassName,
        sideContentPosition: sideContentPosition,
        sideContent: sideContent,
    };

    //Rendering Functions
    return <AutoCompleteDropdown {...userCapacityProps} />
}
